export default __webpack_public_path__ + "static/media/LINK-BNB.4a09eba2.svg";